
import { DownloadCloud, FileSearch, Filter, BarChart, Clock, CheckCircle, TrendingUp, BrainCog, Award, Sparkles, Target } from "lucide-react";
import { FeaturePageLayout } from "@/components/layout/FeaturePageLayout";
import { BenefitCard } from "@/components/ui/benefit-card";
import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
const DataIntegration = () => {
  const {
    t
  } = useTranslation("platform");
  const integrationBenefits = [{
    title: t("dataIntegration.realTimeMonitoring"),
    description: t("dataIntegration.realTimeMonitoringDescription"),
    icon: <Clock className="h-5 w-5 text-primary" />
  }, {
    title: t("dataIntegration.advancedFiltering"),
    description: t("dataIntegration.advancedFilteringDescription"),
    icon: <Filter className="h-5 w-5 text-primary" />
  }, {
    title: t("dataIntegration.comprehensiveCoverage"),
    description: t("dataIntegration.comprehensiveCoverageDescription"),
    icon: <CheckCircle className="h-5 w-5 text-primary" />
  }, {
    title: t("dataIntegration.tenderAnalytics"),
    description: t("dataIntegration.tenderAnalyticsDescription"),
    icon: <BarChart className="h-5 w-5 text-primary" />
  }];
  const statistics = [{
    icon: <Clock className="h-8 w-8 text-primary" />,
    value: "73%",
    label: t("tenderAnalysis.stats.time")
  }, {
    icon: <TrendingUp className="h-8 w-8 text-primary" />,
    value: "42%",
    label: t("tenderAnalysis.stats.rate")
  }, {
    icon: <Award className="h-8 w-8 text-primary" />,
    value: "5.2x",
    label: t("tenderAnalysis.stats.roi")
  }, {
    icon: <FileSearch className="h-8 w-8 text-primary" />,
    value: "1000+",
    label: t("tenderAnalysis.stats.criteria")
  }];
  return <FeaturePageLayout title={t("dataIntegration.combinedTitle")} subtitle={t("dataIntegration.subtitle")} description={t("dataIntegration.combinedDescription")} icon={<DownloadCloud className="h-8 w-8 text-white" />} bgColor="bg-gradient-to-r from-primary/90 via-purple-600/90 to-primary/90">
      {/* Combined content from both tabs */}
      <section className="mb-20">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">{t("dataIntegration.howWorks")}</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t("dataIntegration.howWorksDescription")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} viewport={{
          once: true
        }} className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <FileSearch className="h-5 w-5 mr-2 text-primary" />
              {t("dataIntegration.continuousMonitoring")}
            </h3>
            <p className="text-gray-600 mb-4">
              {t("dataIntegration.continuousMonitoringDescription")}
            </p>
            
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} viewport={{
          once: true
        }} className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <BarChart className="h-5 w-5 mr-2 text-primary" />
              {t("dataIntegration.smartProcessing")}
            </h3>
            <p className="text-gray-600 mb-4">
              {t("dataIntegration.smartProcessingDescription")}
            </p>
            
          </motion.div>
        </div>
      </section>

      {/* Key Data Integration Features */}
      <section className="mb-20">
        
      </section>

      {/* Benefits Section */}
      
      
      {/* Analytics Section - Integrated from the Analysis tab */}
      

      {/* Dashboard Section - From the Analysis tab */}
      
    </FeaturePageLayout>;
};
export default DataIntegration;
